// extracted by mini-css-extract-plugin
export default {"root":"Input_root__wqtCr","auth":"Input_auth__sOZpa","error":"Input_error__whXBU","isIOS":"Input_isIOS__zZh2i"};